/**
 * CustomProperty model
 */

export class CustomProperty {
    Name: string = "";
    Value: string = "";

    cloneForDiff(): { Value: string } {
        return {
            Value: this.Value,
        };
    }
}

export function SetupCustomPropertyData(GameData: any[]): CustomProperty {
    const CurProperty = new CustomProperty();
    CurProperty.Name = GameData[0];
    CurProperty.Value = GameData[1];
    return CurProperty;
}
